import proj4 from "proj4";
import Highcharts from "highcharts";

// Note that we load Highcharts modules source files to allow for a better debugging
// experience.
import "highcharts/modules/map.src";
import "highcharts/modules/tiledwebmap.src";
import "highcharts/modules/marker-clusters.src";
import "highcharts/modules/exporting.src";
import "highcharts/modules/offline-exporting.src";
import "highcharts/modules/export-data.src";
import "highcharts/modules/wordcloud.src";
import "highcharts/modules/pattern-fill.src";

// The accessibility module should be loaded after the exporting module
import "highcharts/modules/accessibility.src";

import { initializeHighchartsLocale } from "./highchartsLocale";

// The proj4 tool is used by Highcharts maps to handle geolocation data, and is required
// to exist within the `window` scope before Highcharts map module is initialized, as it
// will check wether the `window.proj4` function exist before it decides to initialize
// its geolocation data handling system.
if (typeof window !== "undefined") {
  window.proj4 = proj4;
}

initializeHighchartsLocale(Highcharts);

// Add Highcharts to window to allow highcharts plugins that expect it to exist in the
// window scope to access it, like map data JS files.
if (typeof window !== "undefined") {
  window.Highcharts = Highcharts;
}

export default Highcharts;
